import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dashboardData: null,
  loading: false,
  error: null,
};

const analyticsSlice = createSlice({
  name: "analytics",
  initialState,
  reducers: {
    fetchDashboardStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchDashboardSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.dashboardData = action.payload;
    },
    fetchDashboardFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      console.error('Redux Error:', action.payload); // Debug log
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { 
  fetchDashboardStart,
  fetchDashboardSuccess,
  fetchDashboardFailure,
  setLoading, 
  setError,
} = analyticsSlice.actions;

export default analyticsSlice.reducer;